import { Securities } from 'api';
import { BOLD_DIVISION_ROW_HEADER_CONFIG } from 'pages/Valuations/approaches/backsolveApproach/constants';

const getRowConfig = (referencedSecurities: Securities[]) => [
  {
    largeHeader: true,
    skipParse: true,
  },
  ...referencedSecurities.map(security => ({
    ignoreRowCopy: true,
    security,
  })),
  {
    className: `${BOLD_DIVISION_ROW_HEADER_CONFIG.className} division-top-only`,
    skipParse: true,
  },
];

export default getRowConfig;
